import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import {
  getSelectOptions,
  updateComponent,
  fetchData
} from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import { camelize } from '../../utils'
import { uniqBy } from 'lodash'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import MobileDetect from 'mobile-detect'
class Select extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (
      this.props.component.hasOwnProperty('options') &&
      (this.props.component.values || []).length === 0 &&
      !this.props.component.fetchInProgress
    ) {
      const { dispatch } = this.props
      this.props.component.fetchInProgress = true
      dispatch(getSelectOptions(this.props.component))
    }
  }

  componentDidMount() {
    const { dispatch /* , step */ } = this.props
    //const componentId = this.props.component.id
    // if (
    //   this.props.component.hasOwnProperty('fetch') &&
    //   !componentId.startsWith('PROFESSIONE_ATTIVITA-') &&
    //   step.name.toLowerCase() === 'info legali'
    // ) {
    //setTimeout(dispatch(fetchData(this.props.component.id, null, true)), 3000)
    dispatch(fetchData(this.props.component.id, null, true))
    this.aziendaSubType(this.props.component.id,this.props.component.value)
  }
  
  componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props
    if (
      (nextProps.component &&
        this.props.component.values.length === 0 &&
        nextProps.component.values.length >= 0) ||
      (nextProps.component &&
        this.props.component.values.length > 0 &&
        nextProps.component.values.length === 0)
    ) {
      if (!this.props.component.value && !!this.props.component.initialValue) {
        this.props.component.value = this.props.component.initialValue
      }

      if (
        this.props.component.hasOwnProperty('options') &&
        (this.props.component.values || []).length === 0 &&
        !this.props.component.fetchInProgress
      ) {
        this.props.component.fetchInProgress = true
        dispatch(getSelectOptions(this.props.component))
      }
    }
  }

  onValueChange(e) {
    const { dispatch, component } = this.props
    this.aziendaSubType(component.id,e.target.value)
    dispatch(updateComponent(component.id, { value: e.target.value }))
    e.preventDefault()
  }

  renderOptions() {
    const { component } = this.props
    if(component.id==='AZIENDA_TYPE-TIPO_SOGGETTO_AZIENDA' && component.values.length===0)
    {
      this.props.component.rawValue.map(v=>{
        var item={}
        item.value=v.tipoSoggettoId,
        item.description=v.tipoSoggettoDesc
        component.values.push(item);
        });
    }
    let values = component.values
    let isObjectArray = false
    if (
      values &&
      values.constructor.toString().indexOf('Array') > -1 &&
      typeof values[0] === 'object'
    ) {
      values = values.filter(v => !!v.value && v.value !== '-1')
      isObjectArray = true
      values = uniqBy(values, 'value')
    } else {
      values = Array.from(new Set(values))
    }
    return values.map(v => {
      if (!isObjectArray) {
        v = {
          value: v,
          label: v
        }
      }
      if (!v.label && !!v.description) {
        v.label =
          component.flag === 'static_1' &&
          (v.description === 'NAZIONE' ||
            //  || v.description === 'PROVINCIA' || v.description==='RESIDENZA-PROVINCIA' || v.description==='DOMICILIO-PROVINCIA'
            //|| v.description==='SEDE_LEGALE-PROVINCIA' || v.description==='SEDE_AMMINISTRATIVA-PROVINCIA' ||
            component.name === 'PROVINCIA' || component.name === 'CITTADINANZA')
            ? v.value
            : v.description
      }
      // if (!v.label && !!v.value) {
      //   v.label = v.value
      // }
      return (
        <option
          {...css(this.props.styles.option)}
          value={v.value}
          key={v.value}
        >
          {v.label}
        </option>
      )
    })
  }

  validateRequired() {
    const { component } = this.props
    if (
      component.validations &&
      component.validations.isRequired &&
      !component.isDisabled
    ) {
      return true
    }
    return false
  }
  aziendaSubType(componentid,componentvalue){
    const { dispatch /* , step */ } = this.props
 if(componentid==='AZIENDA_TYPE-TIPO_SOGGETTO_AZIENDA')
    {
      if(componentvalue==='1054')
      {
      dispatch(updateComponent('AZIENDA_SUBTYPE-ENTE_PRIVATO', { status: [''] }))
      dispatch(updateComponent('AZIENDA_SUBTYPE-FORMA_GIURIDIA', { status: ['hidden'] }))
      dispatch(updateComponent('AZIENDA_SUBTYPE-SOCIETA_DI_PERSONE_CAPITALE', { status: ['hidden'] }))
      dispatch(updateComponent('AZIENDA_SUBTYPE-SOCIETA_COOPERATIVA', { status: ['hidden'] }))  
    }
      else if(componentvalue==='1050' || componentvalue==='1049')
      {
        dispatch(updateComponent('AZIENDA_SUBTYPE-ENTE_PRIVATO', { status: ['hidden'] }))
        dispatch(updateComponent('AZIENDA_SUBTYPE-SOCIETA_DI_PERSONE_CAPITALE', { status: [''] }))
        dispatch(updateComponent('AZIENDA_SUBTYPE-FORMA_GIURIDIA', { status: [''] }))
        dispatch(updateComponent('AZIENDA_SUBTYPE-SOCIETA_COOPERATIVA', { status: ['hidden'] }))
      }
      else if(componentvalue==='1051')  
      {
        dispatch(updateComponent('AZIENDA_SUBTYPE-ENTE_PRIVATO', { status: ['hidden'] }))
        dispatch(updateComponent('AZIENDA_SUBTYPE-SOCIETA_DI_PERSONE_CAPITALE', { status: ['hidden'] }))
        dispatch(updateComponent('AZIENDA_SUBTYPE-FORMA_GIURIDIA', { status: ['hidden'] }))
        dispatch(updateComponent('AZIENDA_SUBTYPE-SOCIETA_COOPERATIVA', { status: [''] }))
        
      }
    }
  }

  render() {
    const { widget, component } = this.props
    const md = new MobileDetect(window.navigator.userAgent)
    return (
      <div {...css(this.props.styles.component,component.fullWidth && this.props.styles.singleField,component.id==='CELLULARE-PREF_CELLULARE' &&
      !md.mobile() && this.props.styles.divPrefix)}>
        <select
          {...css(
            this.props.styles.input,
            this.props.styles['input--select'],
            component.status.indexOf('error') > -1 &&
              this.props.styles['input--invalid'],
            component.status.indexOf('loading') > -1 &&
              this.props.styles['input--blink'],
            !component.value && this.props.styles['input--unset']
          )}
          onChange={event => {
            this.onValueChange(event)
          }}
          value={component.value || 'Seleziona'}
          disabled={
            !!component.isDisabled ||
            component.status.indexOf('readonly') > -1 ||
            widget.status.indexOf('readonly') > -1
          }
          name={component.id}
        >
          <option
            value="Seleziona"
            disabled={!component.isGrouped && component.isGrouped !== true}
          >
            {component.cleanName}
          </option>
          {this.renderOptions()}
        </select>
        <span
          {...css(
            this.props.styles.label,
            component.value !== '' && this.props.styles['label--active'],
            this.props.isInModal && this.props.styles['label--neutral']
          )}
        >
          {component.cleanName}
        </span>
        <small {...css(this.props.styles['error-msg'])}>
          {camelize(component.errorMessage[0], true, true)}
        </small>
      </div>
    )
  }
}

Select.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  isInModal: PropTypes.bool
}

const mapStateToProps = (state /*, ownProps*/) => {
  const { step } = state
  /*return { component: components[ownProps.component.id] }*/
  return { step }
}

export default connect(mapStateToProps)(withStyles(Styles)(Select))



// WEBPACK FOOTER //
// ./components/select/index.js